import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue';
import { useDealInsightsContext } from '../../../../../context/DealInsightsContext';

export const useAudiencesTableData = () => {
  const { dealInsights } = useDealInsightsContext();
  const { data, chartsLoadingState } = dealInsights;

  const transformedData =
    data?.audiences.objects.map(item => {
      const viewabilityPercentage =
        item.viewability !== null && item.viewability !== undefined ? item.viewability * 100 : null;

      return {
        // Raw values for coloring/visualization
        ...item,
        avg_frequency_raw: item.avg_frequency,
        impressions_raw: item.impressions,
        uniques_raw: item.uniques,
        viewability_raw: item.viewability ?? null,
        spend_raw: item.spend,
        // Formatted values for display
        avg_frequency: abbreviateNumericValue(item.avg_frequency, { allowZero: true, nullValue: 'N/A' }),
        impressions: abbreviateNumericValue(item.impressions, { allowZero: true, nullValue: 'N/A' }),
        uniques: abbreviateNumericValue(item.uniques, { allowZero: true, nullValue: 'N/A' }),
        viewability: abbreviateNumericValue(viewabilityPercentage, { allowZero: true, nullValue: 'N/A' }),
        spend: abbreviateNumericValue(item.spend, { allowZero: true, nullValue: 'N/A' }),
      };
    }) ?? [];

  return {
    data: transformedData,
    isLoading: !!chartsLoadingState.audiences,
  };
};
